import { useContext, useEffect } from 'react';
import { Grid, MenuItem, TextField as MuiTextField, FormControlLabel, Checkbox, Typography } from '@material-ui/core';
import { Field, useFormikContext } from 'formik';
import { TextField } from 'formik-material-ui';
import { Autocomplete } from 'formik-material-ui-lab';
import { adminUserContext } from '../AdminUserContext';
import { UserType } from 'helpers/enums';
import { applicationContext } from 'helpers/services/ApplicationContext';


interface IProps {
    isNew: boolean
}

let UserForm = ({ isNew }: IProps) => {
    let appService = useContext(applicationContext);
    let service = useContext(adminUserContext);

    let form = useFormikContext<typeof service.user>();

    useEffect(() => {
        if (isNew === true)
            form.setFieldValue("resetPassword", true);
    }, [isNew])

    return (
        <Grid container>
            <Grid item xs={12}>
                <Field
                    component={TextField}
                    select
                    label="User type"
                    name="userType"
                    variant="outlined"
                    onChange={(e: any) => form.setFieldValue('userType', e.target.value)}
                    disabled={isNew === false}
                >
                    <MenuItem value={UserType.Videndum}>{UserType.Videndum}</MenuItem>
                    <MenuItem value={UserType.External}>{UserType.External}</MenuItem>
                </Field>
            </Grid>
            <Grid item xs={12}>
                <Field
                    component={TextField}
                    label="Email"
                    name="email"
                    type="email"
                    variant="outlined"
                    disabled={isNew === false}
                />
            </Grid>

            <Grid item xs>
                <Field
                    component={TextField}
                    label="Firstname"
                    name="firstName"
                    variant="outlined"
                />
            </Grid>
            <Grid item xs>
                <Field
                    component={TextField}
                    label="Lastname"
                    name="lastName"
                    variant="outlined"
                />
            </Grid>
            {form.values.userType === UserType.External &&
                <>
                    <Grid item xs={12}>
                        <Field
                            component={TextField}
                            label="Company"
                            name="company"
                            variant="outlined"
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <Field
                            component={Autocomplete}
                            name='countryCode'
                            options={appService.countries.map(x => x.key)}
                            getOptionLabel={(option: string) => appService.countries.getValueByKey(option)}
                            renderInput={(params: any) => (
                                <MuiTextField
                                    {...params}
                                    variant="outlined"
                                    error={form.touched['countryCode'] && !!form.errors['countryCode']}
                                    helperText={form.touched['countryCode'] && form.errors['countryCode']}
                                    label="Country"
                                />
                            )}
                        />
                    </Grid>
                </>
            }

            <Grid item xs={12}>
                <Typography><b>Permissions</b></Typography>
                <FormControlLabel
                    label="Serial numbers editor"
                    name="isSerialNumbersEditor"
                    value={form.values.isSerialNumbersEditor}
                    checked={form.values.isSerialNumbersEditor}
                    onChange={(e: any) => form.setFieldValue('isSerialNumbersEditor', e.target.checked)}
                    control={<Field type="checkbox" name="isSerialNumbersEditor" component={Checkbox} />}
                />
            </Grid>
        </Grid>
    )
}

export default UserForm;